// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"bee662697abb1d307d7f","293":"e2f81dd0428a606d7d1e","518":"2cc62d135a9fe78bad87","779":"88a25be545fe7547ab68"}[chunkId] + ".js";
};